<template>
  <AdminLayout page="Tests" title="Tests">
    <h1>Edit and manage tests</h1>
    <div v-if="property">
      <p>{{ property.name }}</p>
      <div
        v-for="program in trainingPrograms"
        :key="program.trainingProgramId"
        class="p-4 pt-2 my-2 border-t"
        :class="program.isActive ? 'bg-gray-100' : 'bg-gray-400'"
      >
        <div class="flex">
          <div class="flex-grow rounded py-1 px-2">
            <div class="font-medium">
              {{ program.name }} <span v-if="!program.isActive">(inactive)</span>
            </div>
          </div>
        </div>
        <p
          v-for="module in program.trainingModules"
          :key="module.trainingModuleId"
          class="rounded"
        >
          <span class="text-sm pl-4">
            {{ module.name }} <span v-if="!module.isActive">(inactive)</span>
          </span>
        </p>
      </div>
    </div>
  </AdminLayout>
</template>

<script setup lang="ts">
import { useTrainingStore } from "../../store/trainingStore";
import { useBldgStore } from "../../store/bldgStore";

const bldgStore = useBldgStore();
const trainingStore = useTrainingStore();

var property = ref(bldgStore.building);
var trainingPrograms = computed(() => trainingStore.portalTrainingPrograms);
var isTrainingProgramsLoading = ref(true);

onMounted(loadData);

async function loadData() {
  if (property.value?.portalId) {
    isTrainingProgramsLoading.value = true;
    console.log("Loading data for portalId:", property.value.portalId);
    await trainingStore.getTrainingProgramsByPortal(property.value.portalId);
    isTrainingProgramsLoading.value = false;
  }
}
</script>
